import { toast } from 'react-toastify';
import { TIoTDevice } from '@treedis/tour-loader';
import { snakeCase } from 'lodash';
import { LockdownIcon, LockedIcon, UnlockedIcon } from './icons';

const CDN = 'https://cdn.treedis.com/assets';

const LOCKED_IMAGE_TITLE = 'iot_locked_image';
const UNLOCKED_IMAGE_TITLE = 'iot_unlocked_image';
const LOCKDOWN_IMAGE_TITLE = 'iot_lockdown_image';

export const IOT_TOAST_CONFIG = {
  hideProgressBar: true,
  autoClose: 3000,
  closeOnClick: false,
  closeButton: false,
  style: {
    borderRadius: '3px',
    background: 'rgba(0, 0, 0, 0.7)',
    color: '#fff',
    height: '40px',
  },
};

export const iotToast = (message: string, icon?: 'lockdown' | 'unlocked' | 'locked', type?: 'info' | 'error') => {
  const t = type ? toast[type] : toast;

  t(message, {
    ...IOT_TOAST_CONFIG,
    // eslint-disable-next-line no-nested-ternary
    icon: icon === 'lockdown' ? LockdownIcon : icon === 'unlocked' ? UnlockedIcon : icon === 'locked' ? LockedIcon : undefined,
    // To prevent duplicate toasts
    toastId: snakeCase(message),
  });
};

export const getDeviceMediaImage = (d: TIoTDevice) => {
  if (d.lockedDown) {
    return {
      title: LOCKDOWN_IMAGE_TITLE,
      url: `${CDN}/lockdown_high_res.png`,
    };
  }
  if (d.unlocked) {
    return {
      title: UNLOCKED_IMAGE_TITLE,
      url: `${CDN}/unlocked_high_res.png`,
    };
  }
  return {
    title: LOCKED_IMAGE_TITLE,
    url: `${CDN}/locked_high_res.png`,
  };
};
